import { MapGroupId } from "../../types";
import img from "../../mapImages/Labyrinth.webp";

const mapData = {
  groupId: MapGroupId.Labyrinth,
  groupName: {
    en: "Labyrinth",
    ru: "Лабиринт",
  },
  title: {
    en: "Main",
    ru: "Главная",
  },
  imgPath: img,
  extracts: [],
};

export default mapData;
